import AxiosInstance from './request'

export class BaseService {
    protected readonly http = AxiosInstance;

    constructor(protected readonly endpointPath: string) {}
}